import React, { useState, useMemo, useEffect } from 'react';

import Dropdown from '../../components/common/Dropdowns/Dropdown';
import CheckBoxWithText from '../../components/common/CheckBox/CheckBoxWithText';

import { useCommonStore } from '../../stores/commonStore';

import { GoLiveFSNModel, Option } from '../../types/common';

import { ArInfoOptions } from '../../utils/constants/arMeta';

const ArInfoFlags = () => {
    const fsns = useCommonStore((state) => state.goLiveFsns);
    const activeProduct = useCommonStore((state) => state.activeFSN);
    const setFSNModelMetaData = useCommonStore((state) => state.setFSNModelMetaData);

    const [fsnArInfo, setFSNArInfo] = useState<Option>(ArInfoOptions[0]);

    const shouldDisable3DinPP = useMemo(() => {
        if (fsns?.length && activeProduct) {
            const fitFor3DInPP = fsns.find((item) => item.fsn === activeProduct)?.fitFor3DInPP;
            return !fitFor3DInPP;
        }
        return false;
    }, [fsns, activeProduct]);

    useEffect(() => {
        const fsnIdx = fsns?.findIndex((item: GoLiveFSNModel) => item.fsn === activeProduct);
        if (fsns && fsnIdx !== undefined && fsnIdx !== -1) {
            setFSNArInfo(fsns[fsnIdx].arInfoData);
        }
    }, [activeProduct, fsns]);

    const handleDropdownChange = (selectedOption) => {
        setFSNModelMetaData('arInfoData', selectedOption);
    };

    return (
        <div className="flex flex-col gap-4">
            <Dropdown label="Select an AR Info Type" options={ArInfoOptions} onChange={handleDropdownChange} selected={fsnArInfo} />

            <div className="flex flex-row flex-wrap gap-4">
                <CheckBoxWithText id="enable3DinPP" label="Enable3DinPP" shouldDisable3DinPP={shouldDisable3DinPP} fsnArInfo={fsnArInfo} />
                <CheckBoxWithText id="enableSizeCompare" label="EnableSizeCompare" fsnArInfo={fsnArInfo} />
                <CheckBoxWithText id="enableFitInThreeDExperienceOnPP" label="EnableFitInThreeDExperienceOnPP" fsnArInfo={fsnArInfo} />
                <CheckBoxWithText id="enableDimension" label="EnableDimension" fsnArInfo={fsnArInfo} />
                <CheckBoxWithText id="enableLiteMobileHotspot" label="EnableHotspot" fsnArInfo={fsnArInfo} />
            </div>
        </div>
    );
};

export default React.memo(ArInfoFlags);
